import { checkWindow } from '@vfit/shared/data-access';

export const getFromLocalStorageByKey = (key: string) => {
  if (!checkWindow()) return null;
  const dataSaved = localStorage.getItem(key);
  return !!dataSaved && dataSaved !== 'undefined' && JSON.parse(dataSaved as string);
};
